import location from "../../assets/location.svg";
import {
  FaqBadge,
  FaqHeader,
  FaqTitle,
  NavLink,
  NavLinksContainer,
} from "../FAQ/FAQ.styled";
import people from "../../assets/people.png";
import {
  HappyCard,
  HappyCardsContainer,
  HappyContainer,
  HappyParter,
  HappyPartners,
} from "./Happy.styled";
import { FormSection } from "../Forms/Forms.styled";
import cc from "../../assets/CC.svg";
import cc2 from "../../assets/cc2.svg";
import cash from "../../assets/cash.svg";
import p1 from "../../assets/p1.png";
import p2 from "../../assets/p2.png";
import p3 from "../../assets/p3.png";
import p4 from "../../assets/p4.png";
import p5 from "../../assets/p5.png";
import p6 from "../../assets/p6.png";
import General from "../../stores/GeneralStore";
const HappyCenter = () => {
  return (
    <>
      <FaqHeader style={{ background: `url(${people})`, paddingTop: "330px" }}>
        <NavLinksContainer style={{ top: "120px" }}>
          <NavLink to="/">{General?.codeLabels["cm_home"]?.label !== undefined ? General?.codeLabels["cm_home"]?.label : " Home"}</NavLink>&nbsp; /&nbsp;
          <NavLink to="/">Our Services</NavLink>&nbsp; / &nbsp;
          <NavLink to="/">{General?.codeLabels["cm_mob_frqntqstns"]?.label !== undefined ? General?.codeLabels["cm_mob_frqntqstns"]?.label : "Frequently Asked Questions"}</NavLink>
        </NavLinksContainer>
        <FaqTitle style={{ top: "170px" }}>Customer Happiness Centres</FaqTitle>
        <FaqBadge style={{ width: "80%", left: "10%" }}>
          From the first hello to the last goodbye, our Customer Happiness
          Centre team is dedicated to creating a happier customer experience for
          you.
        </FaqBadge>
      </FaqHeader>
      <HappyContainer>
        <FormSection>
          <h2>Customer Service Centers</h2>
          <HappyCardsContainer>
            <HappyCard>
              <span>
                <b>Main Customer Happiness Center</b>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span>
                <img src={location} alt="location" />
                <span>
                  Ground Floor <br /> Al Zahra Building Block B
                </span>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span>
                <img src={location} alt="location" />
                <span>
                  Ground Floor <br /> Al Zahra Building Block B
                </span>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span style={{ width: "80%" }}>
                <img src={location} alt="location" />
                <span style={{ width: "100%" }}>
                  <b>Monday to Friday:</b>
                  <br /> 8:00 AM - 7:00 PM <br /> <b>Saturday:</b> <br /> 10:00
                  AM - 4:30 PM
                </span>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                <img src={cash} alt="cash" />
                <img src={cc2} alt="cc2" />
                <img src={cc} alt="cc" />
              </span>
            </HappyCard>
            <HappyCard>
              <span>
                <b>Main Customer Happiness Center</b>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span>
                <img src={location} alt="location" />
                <span>
                  Ground Floor <br /> Al Zahra Building Block B
                </span>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span>
                <img src={location} alt="location" />
                <span>
                  Ground Floor <br /> Al Zahra Building Block B
                </span>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span style={{ width: "80%" }}>
                <img src={location} alt="location" />
                <span style={{ width: "100%" }}>
                  <b>Monday to Friday:</b>
                  <br /> 8:00 AM - 7:00 PM <br /> <b>Saturday:</b> <br /> 10:00
                  AM - 4:30 PM
                </span>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                <img src={cash} alt="cash" />
                <img src={cc2} alt="cc2" />
                <img src={cc} alt="cc" />
              </span>
            </HappyCard>
            <HappyCard>
              <span>
                <b>Main Customer Happiness Center</b>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span>
                <img src={location} alt="location" />
                <span>
                  Ground Floor <br /> Al Zahra Building Block B
                </span>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span>
                <img src={location} alt="location" />
                <span>
                  Ground Floor <br /> Al Zahra Building Block B
                </span>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span style={{ width: "80%" }}>
                <img src={location} alt="location" />
                <span style={{ width: "100%" }}>
                  <b>Monday to Friday:</b>
                  <br /> 8:00 AM - 7:00 PM <br /> <b>Saturday:</b> <br /> 10:00
                  AM - 4:30 PM
                </span>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                <img src={cash} alt="cash" />
                <img src={cc2} alt="cc2" />
                <img src={cc} alt="cc" />
              </span>
            </HappyCard>
            <HappyCard>
              <span>
                <b>Main Customer Happiness Center</b>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span>
                <img src={location} alt="location" />
                <span>
                  Ground Floor <br /> Al Zahra Building Block B
                </span>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span>
                <img src={location} alt="location" />
                <span>
                  Ground Floor <br /> Al Zahra Building Block B
                </span>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span style={{ width: "80%" }}>
                <img src={location} alt="location" />
                <span style={{ width: "100%" }}>
                  <b>Monday to Friday:</b>
                  <br /> 8:00 AM - 7:00 PM <br /> <b>Saturday:</b> <br /> 10:00
                  AM - 4:30 PM
                </span>
              </span>
              <span>---- ---- ---- ---- ---- ----</span>
              <span
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                <img src={cash} alt="cash" />
                <img src={cc2} alt="cc2" />
                <img src={cc} alt="cc" />
              </span>
            </HappyCard>
          </HappyCardsContainer>
        </FormSection>
        <FormSection>
          <h2>Partners</h2>
          <HappyPartners>
            <HappyParter>
              <img src={p1} alt="" />
            </HappyParter>
            <HappyParter>
              <img src={p2} alt="" />
            </HappyParter>
            <HappyParter>
              <img src={p3} alt="" />
            </HappyParter>
            <HappyParter>
              <img src={p4} alt="" />
            </HappyParter>
            <HappyParter>
              <img src={p5} alt="" />
            </HappyParter>
            <HappyParter>
              <img src={p6} alt="" />
            </HappyParter>
          </HappyPartners>
        </FormSection>
      </HappyContainer>
    </>
  );
};

export default HappyCenter;
